/*
  eslint-disable @typescript-eslint/no-unused-vars
*/
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import AppConfig from 'AppConfig'

import { IConfig } from './model'

const Config: IConfig = {
  api: {
    baseUrl: AppConfig.API_BASE_URL,
  },
  auth: {
    clientId: AppConfig.AUTH_CLIEND_ID,
    authority: AppConfig.AUTH_AUTHORITY || undefined,
    scopes: AppConfig.AUTH_SCOPES || [],
  },
}

export function useConfig(): IConfig {
  return Config
}

export default Config
